class QuickReferenceSlider extends HTMLElement {
  connectedCallback() {
    this.viewport = this.querySelector('.qrs__viewport');
    this.track = this.querySelector('.qrs__track');
    this.slides = Array.from(this.querySelectorAll('.qrs__slide'));
    this.prevBtn = this.querySelector('.qrs__arrow--prev');
    this.nextBtn = this.querySelector('.qrs__arrow--next');
    this.dots = Array.from(this.querySelectorAll('.qrs__dot'));

    if (!this.viewport || !this.track || this.slides.length < 2) return;

    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => this.scrollByCards(-1));
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => this.scrollByCards(1));
    }

    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => this.scrollToSlide(index));
    });

    this._onScroll = this.onScroll.bind(this);
    this.viewport.addEventListener('scroll', this._onScroll, { passive: true });
    window.addEventListener('resize', this._onScroll, { passive: true });

    this.setupActiveDotObserver();
    this.onScroll();
  }

  disconnectedCallback() {
    if (this.viewport && this._onScroll) {
      this.viewport.removeEventListener('scroll', this._onScroll);
    }
    window.removeEventListener('resize', this._onScroll);
    if (this._observer) this._observer.disconnect();
  }

  scrollByCards(direction) {
    const slide = this.slides[0];
    const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
    const amount = (slide.getBoundingClientRect().width + gap) * direction;
    this.viewport.scrollBy({ left: amount, behavior: 'smooth' });
  }

  scrollToSlide(index) {
    const slide = this.slides[index];
    if (!slide) return;
    this.viewport.scrollTo({
      left: slide.offsetLeft - this.track.offsetLeft,
      behavior: 'smooth',
    });
  }

  onScroll() {
    if (this.prevBtn) {
      this.prevBtn.disabled = this.viewport.scrollLeft <= 4;
    }
    if (this.nextBtn) {
      const maxScroll = this.viewport.scrollWidth - this.viewport.clientWidth;
      this.nextBtn.disabled = this.viewport.scrollLeft >= maxScroll - 4;
    }
  }

  setupActiveDotObserver() {
    if (!this.dots.length || !('IntersectionObserver' in window)) return;

    this._observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const index = this.slides.indexOf(entry.target);
          if (index === -1) return;
          this.dots.forEach((dot, i) => {
            dot.setAttribute('aria-current', i === index ? 'true' : 'false');
          });
        });
      },
      { root: this.viewport, threshold: 0.6 }
    );

    this.slides.forEach((slide) => this._observer.observe(slide));
  }
}

if (!customElements.get('quick-reference-slider')) {
  customElements.define('quick-reference-slider', QuickReferenceSlider);
}
